import { defineComponent as et, watchEffect as Q, ref as F, toRef as ne, computed as p, h as i, Fragment as ie, nextTick as tt } from "vue";
import { getDefaultPageSize as at, createPageItemsInfo as nt } from "./ghl-ui.es1064.js";
import it from "./ghl-ui.es1065.js";
import { useRtl as ot } from "./ghl-ui.es851.js";
import { warn as rt, warnOnce as oe } from "./ghl-ui.es853.js";
import st from "./ghl-ui.es854.js";
import pe from "./ghl-ui.es855.js";
import lt from "./ghl-ui.es919.js";
import re from "./ghl-ui.es712.js";
import { smallerSize as se } from "./ghl-ui.es1002.js";
import { createKey as r } from "./ghl-ui.es384.js";
import { useThemeClass as dt } from "./ghl-ui.es857.js";
import { resolveSlot as ut } from "./ghl-ui.es860.js";
import le from "./ghl-ui.es182.js";
import ct from "./ghl-ui.es359.js";
import y from "./ghl-ui.es862.js";
import de from "./ghl-ui.es1066.js";
import ue from "./ghl-ui.es1067.js";
import ce from "./ghl-ui.es1068.js";
import fe from "./ghl-ui.es1069.js";
import me from "./ghl-ui.es1070.js";
import ft from "./ghl-ui.es352.js";
import mt from "./ghl-ui.es1071.js";
import { call as R } from "./ghl-ui.es876.js";
import { useAdjustedTo as pt } from "./ghl-ui.es877.js";
const gt = Object.assign(Object.assign({}, pe.props), {
  simple: Boolean,
  page: Number,
  defaultPage: {
    type: Number,
    default: 1
  },
  itemCount: Number,
  pageCount: Number,
  defaultPageCount: {
    type: Number,
    default: 1
  },
  showSizePicker: Boolean,
  pageSize: Number,
  defaultPageSize: Number,
  pageSizes: {
    type: Array,
    default() {
      return [10];
    }
  },
  showQuickJumper: Boolean,
  size: {
    type: String,
    default: "medium"
  },
  disabled: Boolean,
  pageSlot: {
    type: Number,
    default: 9
  },
  selectProps: Object,
  prev: Function,
  next: Function,
  goto: Function,
  prefix: Function,
  suffix: Function,
  label: Function,
  displayOrder: {
    type: Array,
    default: ["pages", "size-picker", "quick-jumper"]
  },
  to: pt.propTo,
  showQuickJumpDropdown: {
    type: Boolean,
    default: !0
  },
  "onUpdate:page": [Function, Array],
  onUpdatePage: [Function, Array],
  "onUpdate:pageSize": [Function, Array],
  onUpdatePageSize: [Function, Array],
  /** @deprecated */
  onPageSizeChange: [Function, Array],
  /** @deprecated */
  onChange: [Function, Array]
}), Dt = et({
  name: "Pagination",
  props: gt,
  setup(t) {
    process.env.NODE_ENV !== "production" && Q(() => {
      t.pageCount !== void 0 && t.itemCount !== void 0 && rt("pagination", "`page-count` and `item-count` should't be specified together. Only `item-count` will take effect."), t.onPageSizeChange && oe("pagination", "`on-page-size-change` is deprecated, please use `on-update:page-size` instead."), t.onChange && oe("pagination", "`on-change` is deprecated, please use `on-update:page` instead.");
    });
    const {
      mergedComponentPropsRef: n,
      mergedClsPrefixRef: l,
      inlineThemeDisabled: U,
      mergedRtlRef: g
    } = st(t), h = pe("Pagination", "-pagination", it, mt, t, l), {
      localeRef: E
    } = lt("Pagination"), $ = F(null), V = F(t.defaultPage), m = F(at(t)), d = re(ne(t, "page"), V), v = re(ne(t, "pageSize"), m), b = p(() => {
      const {
        itemCount: e
      } = t;
      if (e !== void 0)
        return Math.max(1, Math.ceil(e / v.value));
      const {
        pageCount: a
      } = t;
      return a !== void 0 ? Math.max(a, 1) : 1;
    }), u = F("");
    Q(() => {
      t.simple, u.value = String(d.value);
    });
    const I = F(!1), P = F(!1), S = F(!1), D = F(!1), W = () => {
      t.disabled || (I.value = !0, k());
    }, L = () => {
      t.disabled || (I.value = !1, k());
    }, q = () => {
      P.value = !0, k();
    }, K = () => {
      P.value = !1, k();
    }, J = (e) => {
      c(e);
    }, C = p(() => nt(d.value, b.value, t.pageSlot, t.showQuickJumpDropdown));
    Q(() => {
      C.value.hasFastBackward ? C.value.hasFastForward || (I.value = !1, S.value = !1) : (P.value = !1, D.value = !1);
    });
    const G = p(() => {
      const e = E.value.selectionSuffix;
      return t.pageSizes.map((a) => typeof a == "number" ? {
        label: `${a} / ${e}`,
        value: a
      } : a);
    }), X = p(() => {
      var e, a;
      return ((a = (e = n == null ? void 0 : n.value) === null || e === void 0 ? void 0 : e.Pagination) === null || a === void 0 ? void 0 : a.inputSize) || se(t.size);
    }), Y = p(() => {
      var e, a;
      return ((a = (e = n == null ? void 0 : n.value) === null || e === void 0 ? void 0 : e.Pagination) === null || a === void 0 ? void 0 : a.selectSize) || se(t.size);
    }), Z = p(() => (d.value - 1) * v.value), H = p(() => {
      const e = d.value * v.value - 1, {
        itemCount: a
      } = t;
      return a !== void 0 && e > a - 1 ? a - 1 : e;
    }), N = p(() => {
      const {
        itemCount: e
      } = t;
      return e !== void 0 ? e : (t.pageCount || 1) * v.value;
    }), _ = ot("Pagination", g, l), k = () => {
      tt(() => {
        var e;
        const {
          value: a
        } = $;
        a && (a.classList.add("transition-disabled"), (e = $.value) === null || e === void 0 || e.offsetWidth, a.classList.remove("transition-disabled"));
      });
    };
    function c(e) {
      if (e === d.value)
        return;
      const {
        "onUpdate:page": a,
        onUpdatePage: M,
        onChange: B,
        simple: ae
      } = t;
      a && R(a, e), M && R(M, e), B && R(B, e), V.value = e, ae && (u.value = String(e));
    }
    function O(e) {
      if (e === v.value)
        return;
      const {
        "onUpdate:pageSize": a,
        onUpdatePageSize: M,
        onPageSizeChange: B
      } = t;
      a && R(a, e), M && R(M, e), B && R(B, e), m.value = e, b.value < d.value && c(b.value);
    }
    function x() {
      if (t.disabled)
        return;
      const e = Math.min(d.value + 1, b.value);
      c(e);
    }
    function ee() {
      if (t.disabled)
        return;
      const e = Math.max(d.value - 1, 1);
      c(e);
    }
    function o() {
      if (t.disabled)
        return;
      const e = Math.min(C.value.fastForwardTo, b.value);
      c(e);
    }
    function te() {
      if (t.disabled)
        return;
      const e = Math.max(C.value.fastBackwardTo, 1);
      c(e);
    }
    function w(e) {
      O(e);
    }
    function A() {
      const e = parseInt(u.value);
      Number.isNaN(e) || (c(Math.max(1, Math.min(e, b.value))), t.simple || (u.value = ""));
    }
    function j() {
      A();
    }
    function f(e) {
      if (!t.disabled)
        switch (e.type) {
          case "page":
            c(e.label);
            break;
          case "fast-backward":
            te();
            break;
          case "fast-forward":
            o();
            break;
        }
    }
    function T(e) {
      u.value = e.replace(/\D+/g, "");
    }
    Q(() => {
      d.value, v.value, k();
    });
    const z = p(() => {
      const {
        size: e
      } = t, {
        self: {
          buttonBorder: a,
          buttonBorderHover: M,
          buttonBorderPressed: B,
          buttonIconColor: ae,
          buttonIconColorHover: ge,
          buttonIconColorPressed: he,
          itemTextColor: ve,
          itemTextColorHover: be,
          itemTextColorPressed: we,
          itemTextColorActive: Ce,
          itemTextColorDisabled: ke,
          itemColor: xe,
          itemColorHover: Fe,
          itemColorPressed: Pe,
          itemColorActive: Se,
          itemColorActiveHover: ze,
          itemColorDisabled: Me,
          itemBorder: Be,
          itemBorderHover: Ie,
          itemBorderPressed: ye,
          itemBorderActive: Re,
          itemBorderDisabled: $e,
          itemBorderRadius: Ne,
          jumperTextColor: Oe,
          jumperTextColorDisabled: Ae,
          buttonColor: je,
          buttonColorHover: Te,
          buttonColorPressed: Ue,
          [r("itemPadding", e)]: Ee,
          [r("itemMargin", e)]: Ve,
          [r("inputWidth", e)]: De,
          [r("selectWidth", e)]: Je,
          [r("inputMargin", e)]: He,
          [r("selectMargin", e)]: _e,
          [r("jumperFontSize", e)]: Qe,
          [r("prefixMargin", e)]: We,
          [r("suffixMargin", e)]: Le,
          [r("itemSize", e)]: qe,
          [r("buttonIconSize", e)]: Ke,
          [r("itemFontSize", e)]: Ge,
          [`${r("itemMargin", e)}Rtl`]: Xe,
          [`${r("inputMargin", e)}Rtl`]: Ye
        },
        common: {
          cubicBezierEaseInOut: Ze
        }
      } = h.value;
      return {
        "--n-prefix-margin": We,
        "--n-suffix-margin": Le,
        "--n-item-font-size": Ge,
        "--n-select-width": Je,
        "--n-select-margin": _e,
        "--n-input-width": De,
        "--n-input-margin": He,
        "--n-input-margin-rtl": Ye,
        "--n-item-size": qe,
        "--n-item-text-color": ve,
        "--n-item-text-color-disabled": ke,
        "--n-item-text-color-hover": be,
        "--n-item-text-color-active": Ce,
        "--n-item-text-color-pressed": we,
        "--n-item-color": xe,
        "--n-item-color-hover": Fe,
        "--n-item-color-disabled": Me,
        "--n-item-color-active": Se,
        "--n-item-color-active-hover": ze,
        "--n-item-color-pressed": Pe,
        "--n-item-border": Be,
        "--n-item-border-hover": Ie,
        "--n-item-border-disabled": $e,
        "--n-item-border-active": Re,
        "--n-item-border-pressed": ye,
        "--n-item-padding": Ee,
        "--n-item-border-radius": Ne,
        "--n-bezier": Ze,
        "--n-jumper-font-size": Qe,
        "--n-jumper-text-color": Oe,
        "--n-jumper-text-color-disabled": Ae,
        "--n-item-margin": Ve,
        "--n-item-margin-rtl": Xe,
        "--n-button-icon-size": Ke,
        "--n-button-icon-color": ae,
        "--n-button-icon-color-hover": ge,
        "--n-button-icon-color-pressed": he,
        "--n-button-color-hover": Te,
        "--n-button-color": je,
        "--n-button-color-pressed": Ue,
        "--n-button-border": a,
        "--n-button-border-hover": M,
        "--n-button-border-pressed": B
      };
    }), s = U ? dt("pagination", p(() => {
      let e = "";
      const {
        size: a
      } = t;
      return e += a[0], e;
    }), z, t) : void 0;
    return {
      rtlEnabled: _,
      mergedClsPrefix: l,
      locale: E,
      selfRef: $,
      mergedPage: d,
      pageItems: p(() => C.value.items),
      mergedItemCount: N,
      jumperValue: u,
      pageSizeOptions: G,
      mergedPageSize: v,
      inputSize: X,
      selectSize: Y,
      mergedTheme: h,
      mergedPageCount: b,
      startIndex: Z,
      endIndex: H,
      showFastForwardMenu: S,
      showFastBackwardMenu: D,
      fastForwardActive: I,
      fastBackwardActive: P,
      handleMenuSelect: J,
      handleFastForwardMouseenter: W,
      handleFastForwardMouseleave: L,
      handleFastBackwardMouseenter: q,
      handleFastBackwardMouseleave: K,
      handleJumperInput: T,
      handleBackwardClick: ee,
      handleForwardClick: x,
      handlePageItemClick: f,
      handleSizePickerChange: w,
      handleQuickJumperChange: j,
      cssVars: U ? void 0 : z,
      themeClass: s == null ? void 0 : s.themeClass,
      onRender: s == null ? void 0 : s.onRender
    };
  },
  render() {
    const {
      $slots: t,
      mergedClsPrefix: n,
      disabled: l,
      cssVars: U,
      mergedPage: g,
      mergedPageCount: h,
      pageItems: E,
      showSizePicker: $,
      showQuickJumper: V,
      mergedTheme: m,
      locale: d,
      inputSize: v,
      selectSize: b,
      mergedPageSize: u,
      pageSizeOptions: I,
      jumperValue: P,
      simple: S,
      prev: D,
      next: W,
      prefix: L,
      suffix: q,
      label: K,
      goto: J,
      handleJumperInput: C,
      handleSizePickerChange: G,
      handleBackwardClick: X,
      handlePageItemClick: Y,
      handleForwardClick: Z,
      handleQuickJumperChange: H,
      onRender: N
    } = this;
    N == null || N();
    const _ = t.prefix || L, k = t.suffix || q, c = D || t.prev, O = W || t.next, x = K || t.label;
    return i("div", {
      ref: "selfRef",
      class: [`${n}-pagination`, this.themeClass, this.rtlEnabled && `${n}-pagination--rtl`, l && `${n}-pagination--disabled`, S && `${n}-pagination--simple`],
      style: U
    }, _ ? i("div", {
      class: `${n}-pagination-prefix`
    }, _({
      page: g,
      pageSize: u,
      pageCount: h,
      startIndex: this.startIndex,
      endIndex: this.endIndex,
      itemCount: this.mergedItemCount
    })) : null, this.displayOrder.map((ee) => {
      switch (ee) {
        case "pages":
          return i(ie, null, i("div", {
            class: [`${n}-pagination-item`, !c && `${n}-pagination-item--button`, (g <= 1 || g > h || l) && `${n}-pagination-item--disabled`],
            onClick: X
          }, c ? c({
            page: g,
            pageSize: u,
            pageCount: h,
            startIndex: this.startIndex,
            endIndex: this.endIndex,
            itemCount: this.mergedItemCount
          }) : i(y, {
            clsPrefix: n
          }, {
            default: () => this.rtlEnabled ? i(de, null) : i(ue, null)
          })), S ? i(ie, null, i("div", {
            class: `${n}-pagination-quick-jumper`
          }, i(le, {
            value: P,
            onUpdateValue: C,
            size: v,
            placeholder: "",
            disabled: l,
            theme: m.peers.Input,
            themeOverrides: m.peerOverrides.Input,
            onChange: H
          })), " / ", h) : E.map((o, te) => {
            let w, A, j;
            const {
              type: f
            } = o;
            switch (f) {
              case "page":
                const z = o.label;
                x ? w = x({
                  type: "page",
                  node: z,
                  active: o.active
                }) : w = z;
                break;
              case "fast-forward":
                const s = this.fastForwardActive ? i(y, {
                  clsPrefix: n
                }, {
                  default: () => this.rtlEnabled ? i(fe, null) : i(ce, null)
                }) : i(y, {
                  clsPrefix: n
                }, {
                  default: () => i(me, null)
                });
                x ? w = x({
                  type: "fast-forward",
                  node: s,
                  active: this.fastForwardActive || this.showFastForwardMenu
                }) : w = s, A = this.handleFastForwardMouseenter, j = this.handleFastForwardMouseleave;
                break;
              case "fast-backward":
                const e = this.fastBackwardActive ? i(y, {
                  clsPrefix: n
                }, {
                  default: () => this.rtlEnabled ? i(ce, null) : i(fe, null)
                }) : i(y, {
                  clsPrefix: n
                }, {
                  default: () => i(me, null)
                });
                x ? w = x({
                  type: "fast-backward",
                  node: e,
                  active: this.fastBackwardActive || this.showFastBackwardMenu
                }) : w = e, A = this.handleFastBackwardMouseenter, j = this.handleFastBackwardMouseleave;
                break;
            }
            const T = i("div", {
              key: te,
              class: [`${n}-pagination-item`, o.active && `${n}-pagination-item--active`, f !== "page" && (f === "fast-backward" && this.showFastBackwardMenu || f === "fast-forward" && this.showFastForwardMenu) && `${n}-pagination-item--hover`, l && `${n}-pagination-item--disabled`, f === "page" && `${n}-pagination-item--clickable`],
              onClick: () => {
                Y(o);
              },
              onMouseenter: A,
              onMouseleave: j
            }, w);
            if (f === "page" && !o.mayBeFastBackward && !o.mayBeFastForward)
              return T;
            {
              const z = o.type === "page" ? o.mayBeFastBackward ? "fast-backward" : "fast-forward" : o.type;
              return o.type !== "page" && !o.options ? T : i(ft, {
                to: this.to,
                key: z,
                disabled: l,
                trigger: "hover",
                virtualScroll: !0,
                style: {
                  width: "60px"
                },
                theme: m.peers.Popselect,
                themeOverrides: m.peerOverrides.Popselect,
                builtinThemeOverrides: {
                  peers: {
                    InternalSelectMenu: {
                      height: "calc(var(--n-option-height) * 4.6)"
                    }
                  }
                },
                nodeProps: () => ({
                  style: {
                    justifyContent: "center"
                  }
                }),
                show: f === "page" ? !1 : f === "fast-backward" ? this.showFastBackwardMenu : this.showFastForwardMenu,
                onUpdateShow: (s) => {
                  f !== "page" && (s ? f === "fast-backward" ? this.showFastBackwardMenu = s : this.showFastForwardMenu = s : (this.showFastBackwardMenu = !1, this.showFastForwardMenu = !1));
                },
                options: o.type !== "page" && o.options ? o.options : [],
                onUpdateValue: this.handleMenuSelect,
                scrollable: !0,
                showCheckmark: !1
              }, {
                default: () => T
              });
            }
          }), i("div", {
            class: [`${n}-pagination-item`, !O && `${n}-pagination-item--button`, {
              [`${n}-pagination-item--disabled`]: g < 1 || g >= h || l
            }],
            onClick: Z
          }, O ? O({
            page: g,
            pageSize: u,
            pageCount: h,
            itemCount: this.mergedItemCount,
            startIndex: this.startIndex,
            endIndex: this.endIndex
          }) : i(y, {
            clsPrefix: n
          }, {
            default: () => this.rtlEnabled ? i(ue, null) : i(de, null)
          })));
        case "size-picker":
          return !S && $ ? i(ct, Object.assign({
            consistentMenuWidth: !1,
            placeholder: "",
            showCheckmark: !1,
            to: this.to
          }, this.selectProps, {
            size: b,
            options: I,
            value: u,
            disabled: l,
            theme: m.peers.Select,
            themeOverrides: m.peerOverrides.Select,
            onUpdateValue: G
          })) : null;
        case "quick-jumper":
          return !S && V ? i("div", {
            class: `${n}-pagination-quick-jumper`
          }, J ? J() : ut(this.$slots.goto, () => [d.goto]), i(le, {
            value: P,
            onUpdateValue: C,
            size: v,
            placeholder: "",
            disabled: l,
            theme: m.peers.Input,
            themeOverrides: m.peerOverrides.Input,
            onChange: H
          })) : null;
        default:
          return null;
      }
    }), k ? i("div", {
      class: `${n}-pagination-suffix`
    }, k({
      page: g,
      pageSize: u,
      pageCount: h,
      startIndex: this.startIndex,
      endIndex: this.endIndex,
      itemCount: this.mergedItemCount
    })) : null);
  }
});
export {
  Dt as default,
  gt as paginationProps
};
